import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BlockingProgressModule } from '@core/modules/blocking-progress/blocking-progress.module';
import { UserNotificationModule } from '@core/modules/user-notification/user-notification.module';
import { ErrorHandlingModule } from '@core/modules/error-handling/error-handling.module';

import { AuthorizationByKeyGuard } from '@core/guards/authorization-by-key.guard';
import { AuthGuard } from '@core/guards/auth.guard';

export class EnsureModuleLoadedOnceGuard {
  constructor(targetModule: any) {
    if (targetModule) {
      throw new Error(`${targetModule.constructor.name} has already been loaded. Import this module in the AppModule only.`);
    }
  }
}

@NgModule({
  imports: [
    // Angular
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,

    // Intern
    UserNotificationModule
  ],
  declarations: [],
  providers: [
    // Guards
    AuthorizationByKeyGuard,
    AuthGuard
  ],
  exports: [
    // Intern
    BlockingProgressModule,
    ErrorHandlingModule,
    UserNotificationModule
  ],
})
export class CoreModule extends EnsureModuleLoadedOnceGuard {
  // Ensure that CoreModule is only loaded into AppModule
  // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    super(parentModule);
  }

  // To make su
  static forRoot(): ModuleWithProviders<CoreModule>[] {
    return [
      {
        ngModule: CoreModule,
        providers: []
      },
      BlockingProgressModule.forRoot(),
      UserNotificationModule.forRoot(),
      ErrorHandlingModule.forRoot()
    ];
  }
}
